// import { openCenteredWindow } from "@peerup/helper"
import { envConfig } from "@peerup/host-env"
import { defineStore } from "pinia"

import { getUumAuthUrlApi } from "@/api/index.api"
import { getRedirectUrl } from "@/utils/url"

export const useSsoStore = defineStore("sso", {
  state: () => ({
    ssoLoading: false,
  }),
  actions: {
    setSsoLoading(loading: boolean) {
      this.ssoLoading = loading
      setTimeout(() => {
        this.ssoLoading = false
      }, 15 * 1000)
    },
    gotoOssLogin() {
      this.setSsoLoading(true)
      getUumAuthUrlApi({ clientId: envConfig.PRIVATE_CLIENT_ID_KEY, jumpUrl: getRedirectUrl() }).then(res => {
        if (res.authUrl) {
          // window.open(res.authUrl, "_blank")
          window.location.href = res.authUrl
          // openCenteredWindow(res.authUrl, "oss-login")
        }
      }).catch(() => {
        this.setSsoLoading(false)
      })
    },
  },
})
